export default __webpack_public_path__ + "static/media/pokemon.32de8610.PNG";